import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LandSubsidenceDashboardService {

  constructor(private http: HttpClient) { }

  getHeirarchy(postData: any) {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + 'locations/heirarchy', postData);
  }

  getLandSubsidenceTableData(payload: any) {
    return this.http.post(
      environment.url.HEATWAVE_STAGING_API_URL + 'landSubsidence/getLandSubsidenceTableData',
      payload
    );
  }

  getSubsidenceTimeseries(postData: any) {
    return this.http.post(
      environment.url.HEATWAVE_STAGING_API_URL + 'subsidence/timeseries',
      postData
    );
  }

  getLandSubsidenceHeatMapData(refTs: number, forecastLength: string) {
    return this.http.get(
      environment.url.HEATWAVE_STAGING_API_URL + `landSubsidence/getLandSubsidenceHeatMapData/${refTs}/${forecastLength}`
    );
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = [];
    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  getImageBounds(imageBounds: any[]): any[] {
    return [
      [imageBounds[1][0], imageBounds[0][1]],
      [imageBounds[1][0], imageBounds[1][1]],
      [imageBounds[0][0], imageBounds[1][1]],
      [imageBounds[0][0], imageBounds[0][1]]
    ];
  }

  getCurrentDateYyyymmdd(): string {
    const d = new Date();
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  }

  getAlertCategory(value: number): string {
    if (value < 10) return 'Low';
    if (value < 30) return 'Moderate';
    if (value < 50) return 'High';
    return 'Very High';
  }

  getAlertBgColor(alert: string): string {
    const colorMap: any = {
      'Low': '#a8d5a2',
      'Moderate': '#f6f94b',
      'High': '#fdba12',
      'Very High': '#f92509',
    };
    return colorMap[alert] || 'transparent';
  }

  getHeatMap(url: any) {
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
        });
    });
  }

  setMapData(data: any) {
    let obj: any = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }
}
